<template>
  <button
    class="up-btn"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'upButton',
  inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
.up-btn {
  width: 100%;
  text-align: center;
  background: #fefefe;
  border: 2px solid #1c1c1c;
  color: #1c1c1c;
}
</style>
